<template>
    <div class="progressBar">
        <i
            class="el-icon-close close-icon"
            @click="goToHomePage"
        ></i>
        <div class="progressPage">
            <p>{{currentPage}}/{{totalPages}}</p>
        </div>
        <div class="progress-bar-static">
            <span class="remaining-time-bar" :style="{'width': `${widthProgress}%` }"></span>
        </div>
        <div class="progressNextPage">
            <p>
                Next page in : {{remainingTime}}
                <i
                    class="el-icon-right pointer-style"
                    @click="goToNextPage"
                ></i>
            </p>
        </div>
        <p id="demo"></p>
    </div>
</template>

<script>
export default {

    name: 'page-display',

    props:{
        totalPages: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            totalTimeInSeconds: this.$store.getters.monitoringRemainingTime,
            remainingSeconds: this.$store.getters.monitoringRemainingTime,
            handlerCountDown: null,
        };
    },

    mounted(){
        this.enableCountDown();
    },

    computed:{
        remainingTime(){
            return this.formatSeconds(this.remainingSeconds);
        },
        widthProgress(){
            // valeur entre 0 et 100
            // 0 si this.remainingSeconds = totalTimeInSeconds
            // 100 si this.remainingSeconds = 0
            return (100 - 100 * this.remainingSeconds / this.totalTimeInSeconds);
            // return `background-color: #409EFF`
        },
    },
    beforeDestroy(){
        this.disableCountDown();
    },
    methods:{
        enableCountDown(){
            this.disableCountDown();
            this.updateRemainingSeconds();
            this.handlerCountDown = setTimeout(() => {
                this.enableCountDown();
            }, 1000);
        },
        disableCountDown(){
            clearTimeout(this.handlerCountDown);
        },
        updateRemainingSeconds(){
            if(this.remainingSeconds === 0) {
                this.remainingSeconds = this.totalTimeInSeconds;
                this.enableCountDown();
                this.$emit('change-current-page');
            } else {
                this.remainingSeconds = this.remainingSeconds - 1;
            }
        },
        formatSeconds(timeInSeconds){
            let minutes = Math.floor(timeInSeconds / 60);
            let seconds = timeInSeconds - minutes * 60;
            return `${minutes<10?'0':''}${minutes}:${seconds<10?'0':''}${seconds}`;
        },
        goToHomePage(){
            this.$router.push('/');
        },
        goToNextPage(){
            this.$emit('change-current-page');
            this.totalTimeInSeconds = this.$store.getters.monitoringRemainingTime;
            this.remainingSeconds = this.$store.getters.monitoringRemainingTime;
        }
    },
};
</script>

<style lang="css" scoped>
p{
    margin-bottom: 0;
}
.remaining-time-bar {
    height: 5px;
    position: absolute;
    border-radius: 2px;
    margin-bottom: 1em;
    background-color: #409EFF;
    width: 100%;
}

.progressBar{
    display: flex;
    margin-top: 10px;
    justify-content: space-between;
    align-items: center;
    background-color: #292B30;
    margin: -1px -15px;
    padding: 0 20px;
    height: 66px;
}

.progress-bar-static{
    background-color: #DCDFE6;
    width: 78%;
    border-radius: 2px;
    height: 5px;
    position: relative;
}

.progressPage, .progressNextPage{
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
}

.progressPage{
    margin-right: 15px;
}

.progressNextPage{
    margin-left: 30px;
}
.pointer-style{
    cursor:  pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/ChannelsOverview/page-display.vue